module.exports = __webpack_public_path__ + "img/20250721.533e9ad3.png";